import { ChatSparkle24Regular, Dismiss24Regular } from "@fluentui/react-icons";

interface HelpChatButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export function HelpChatButton({ isOpen, onClick }: HelpChatButtonProps) {
  return (
    <button
      onClick={onClick}
      className="fixed z-50 flex items-center justify-center w-12 h-12 rounded-full bg-primary text-primary-foreground shadow-lg hover:opacity-90 active:scale-95 transition-all"
      style={{ bottom: "24px", right: "24px" }}
      aria-label={isOpen ? "Fechar assistente" : "Abrir assistente de ajuda"}
      title={isOpen ? "Fechar assistente" : "Assistente AJA2 AI"}
    >
      {isOpen ? (
        <Dismiss24Regular className="w-5 h-5" />
      ) : (
        <ChatSparkle24Regular className="w-5 h-5" />
      )}
    </button>
  );
}
